export const If = ({ condition, children }: { condition: boolean; children?: any }) => {
  return condition ? children : null;
};
